import * as React from "react";
import { SvgRoot } from "./SvgRoot";

const ShieldIcon = props => {
    // tslint:disable
    return (
        <SvgRoot {...props}>
            <g fill="none" stroke={props.nativeColor} strokeLinejoin="round">
                <path d="M15.2,10.1l-3.6,3.4c-0.1,0.1-0.2,0.1-0.3,0.1h0c-0.1,0-0.2-0.1-0.3-0.1l-1.7-1.9"/>
                <path d="M12,3c0.1,0,0.2,0,0.5,0.3c1.7,1.5,3.7,2.3,6.3,2.4c0.3,0,0.5,0.2,0.5,0.5c0,0.6,0,0.9,0,1.2l0,0.1c0,2.3,0,3.4-0.2,4.7c-0.6,4.3-2.7,7.3-7.2,8.8c-4.5-1.5-6.6-4.5-7.2-8.8c-0.2-1.4-0.2-2.5-0.2-4.7l0-0.1c0-0.4,0-0.7,0-1.2c0-0.3,0.2-0.5,0.5-0.5c2.6,0,4.6-0.8,6.3-2.4C11.8,3,11.9,3,12,3z"/>
            </g>
        </SvgRoot>
    );
}

export default ShieldIcon;


// WEBPACK FOOTER //
// ./src/components/Icons/ShieldIcon.tsx